/**
 * The `?section=` URL param contract: a one-shot "scroll the open manifest
 * drawer to this section" signal. The grid's Document Review chips write it
 * (ManifestsV3.tsx) and ManifestDetailSection consumes-and-clears it. Kept
 * dependency-free, mirroring the sibling `reviewParam.ts` contract module.
 */

/** The `?section=` URL param key. */
export const SECTION_PARAM_KEY = "section";

/** Sections that support scroll-on-open. Extend the union to add more. */
export type SectionParam = "documents";

/** Parse the `?section=` value; anything unrecognized is treated as absent. */
export function parseSectionParam(raw: string | null): SectionParam | null {
  return raw === "documents" ? raw : null;
}
